import * as React from "react";
import { cn } from "@/utils/cn";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  icon?: React.ReactNode; // optional left icon
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, icon, ...props }, ref) => {
    const hasIcon = !!icon;

    return (
      <div className="relative w-full">
        {/* Left Icon */}
        {hasIcon && (
          <span
            className={cn(
              "absolute left-3 top-3 text-[#7b2a40] opacity-80 pointer-events-none"
            )}
          >
            {icon}
          </span>
        )}

        <textarea
          ref={ref}
          {...props}
          className={cn(
            "block w-full min-h-[100px] rounded-md border border-gray-300 bg-white text-gray-900 text-sm resize-y",
            "placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#7b2a40]/40 focus:border-[#7b2a40]",
            "disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-150 ease-in-out",
            hasIcon ? "pl-9 pr-3 py-2.5" : "px-3 py-2.5",
            className
          )}
        />
      </div>
    );
  }
);

Textarea.displayName = "Textarea";

export { Textarea };
